import type { ChoiceWithCount, ChoicesWithCountDto } from './choices.types';

type ParseChoicesWithCountForUI = (input: ChoicesWithCountDto) => ChoiceWithCount[];

const parseChoicesWithCountForUI: ParseChoicesWithCountForUI = raw => {
  if (!raw || typeof raw !== 'object') {
    return [];
  }

  return Object.entries(raw).map(([value, entry]) => ({
    value,
    label: entry?.label ?? value,
    count: entry?.count ?? 0,
  }));
};

export { parseChoicesWithCountForUI };
